export const DocumentTypes = ['cpf', 'cnpj'] as const;

export type IDocumentType = (typeof DocumentTypes)[number];

export enum DocumentTypeEnum {
  cpf = 'CPF',
  cnpj = 'CNPJ',
}
